import { apiBaseUrl } from './api';

const jsonFetch = (url, options = {}) =>
  window.fetch(url, {
    credentials: 'include',
    headers: { Accept: 'application/json', ...(options.headers || {}) },
    ...options,
  }).then(async res => {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const error = new Error(data.error || 'Web3 authentication request failed');
      error.status = res.status;
      throw error;
    }
    return data;
  });

export const fetchWeb3AuthNonce = ({ walletAddress, chain = 'evm' }) => {
  const params = new URLSearchParams({
    wallet_address: walletAddress,
    chain,
  });
  return jsonFetch(`${apiBaseUrl()}/api/auth/web3/nonce?${params}`);
};

export const authenticateWithWeb3Signature = ({ walletAddress, signature, nonce, chain = 'evm' }) =>
  jsonFetch(`${apiBaseUrl()}/api/auth/web3-login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      wallet_address: walletAddress,
      signature,
      nonce,
      chain,
    }),
  });

export const fetchWeb3AuthSession = () =>
  jsonFetch(`${apiBaseUrl()}/api/auth/web3/session`).catch(err => {
    if (err.status === 401) {
      return { authenticated: false };
    }
    throw err;
  });

export const logoutWeb3Session = () =>
  jsonFetch(`${apiBaseUrl()}/api/auth/web3/session`, { method: 'DELETE' });

export const signWeb3AuthMessage = async ({ provider, message }) => {
  const signer = provider.getSigner();
  return signer.signMessage(message);
};

export const connectInjectedEvmWallet = async () => {
  if (!window.ethereum) {
    const error = new Error('No EVM wallet detected');
    error.code = 'NO_WALLET';
    throw error;
  }
  const { ethers } = await import('ethers');
  const provider = new ethers.providers.Web3Provider(window.ethereum);
  await provider.send('eth_requestAccounts', []);
  const signer = provider.getSigner();
  const walletAddress = await signer.getAddress();
  return { provider, walletAddress, chain: 'evm' };
};

/** Prompt wallet connect and verify the active account matches a delegated persona address. */
export const connectInjectedEvmWalletForAddress = async requiredAddress => {
  const { provider, walletAddress, chain } = await connectInjectedEvmWallet();
  if (
    requiredAddress &&
    walletAddress.toLowerCase() !== String(requiredAddress).trim().toLowerCase()
  ) {
    const error = new Error(
      'Connected wallet does not match your designated persona wallet. Switch accounts in MetaMask/Rabby and try again.'
    );
    error.code = 'WALLET_MISMATCH';
    error.connectedAddress = walletAddress;
    error.requiredAddress = requiredAddress;
    throw error;
  }
  return { provider, walletAddress, chain };
};
